import { render } from "./ListPublication.vue?vue&type=template&id=1d8d7186&ts=true"
import script from "./ListPublication.vue?vue&type=script&lang=ts"
export * from "./ListPublication.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__